import { useNavigate } from 'react-router-dom';

import Button from '@/components/shared/Button/Button';
import { ROUTES } from '@/lib/routes';
import { useHubStore } from '@/lib/store/hubStore';
import { authService } from '@/services/auth';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authService.signOut();
    navigate(ROUTES.HOME);
    useHubStore.setState({ user: { email: '', role: null } });
  };

  return (
    <Button
      onClick={handleLogout}
      variant="transparent"
      label="Log Out"
      size="s"
      className="flex w-full"
    />
  );
};

export default LogoutButton;
